import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

VueCookies.config('365d', '/', process.env.VUE_APP_COOKIES)
